import { render, staticRenderFns } from "./BankTransferPayment.vue?vue&type=template&id=220c2357&lang=pug&"
import script from "./BankTransferPayment.vue?vue&type=script&lang=js&"
export * from "./BankTransferPayment.vue?vue&type=script&lang=js&"
import style0 from "./BankTransferPayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BankTransferPayment.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VDivider,
  VTextField,
})
